import type {FC} from 'react'
import marketingTemplatesData from '../../../data/marketing/marketingTemplatesData'
import {useParams} from 'react-router-dom'
import CombinedGeneration from '../../universal-components/combined-generation/CombinedGeneration'

import blueDragonMarketingTemplateData from '../../../../white-label/blue-dragon/marketingTemplatesData'
import {isRunningOnKlevereDomain} from '../../../../white-label/permission'

import CombinedFormBlueDragon from '../../../../white-label/blue-dragon/CombinedForm'

interface MarketingTemplatePageProps {}

const MarketingTemplatePage: FC<MarketingTemplatePageProps> = () => {
  const {templateUrl} = useParams()

  let templateItem: any

  if (isRunningOnKlevereDomain()) {
    templateItem = marketingTemplatesData.templates.find((item: any) =>
      item.url.includes(templateUrl)
    )
  } else {
    templateItem = blueDragonMarketingTemplateData.templates.find((item: any) =>
      item.url.includes(templateUrl)
    )
  }

  return <CombinedGeneration templateItem={templateItem} />
}

export default MarketingTemplatePage
